<script>
import ExportIcon from "@/icons/ExportIcon.vue";
import { languages } from "@/api/common";
import apiClient from "@/api/api-client";
import { ElMessageBox } from "element-plus";
import { deleteDictionary } from "@/api/dictionary";
// import { getDictionaryResult } from "@/api/dictionary";

export default {
  name: "DictionaryReportsList",
  components: { ExportIcon },
  data() {
    return {
      wordsList: [],
      loading: false,
      selectedLang: null,
    };
  },
  computed: {
    domain() {
      return window.domain;
    },
    languages() {
      return languages().filter((l) => l.value !== "mx");
    },
  },
  // async created() {
  //   await this.getDictionary();
  // },
  methods: {
    // async getDictionary() {
    //   this.loading = true;
    //   try {
    //     const payload = {
    //       lang: this.selectedLang,
    //     };
    //     const response = await getDictionaryResult(payload);
    //     this.wordsList = response?.success_words;
    //   } catch (err) {
    //     console.error(err);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    downloadFile(filename, fileUrl) {
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async downloadReport(endpoint, params = {}) {
      this.loading = true;
      try {
        const data = await apiClient.post(endpoint, params);

        if (data && data.data && data.data.output_path) {
          const fileUrl = `${this.domain}${data.data.output_path}`;
          this.downloadFile(data.data.file_name, fileUrl);
        } else {
          alert("Не успешно");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async reportDictionary() {
      const params = {};
      if (this.selectedLang) {
        params.lang = this.selectedLang;
      }

      await this.downloadReport("/word/export", params);
    },
    async deleteAllDictionary() {
      try {
        await ElMessageBox.confirm(
          `Вы уверены? Это удалит все слова из словарей </br><span style="font-weight: 600">rus_new</span> и <span style="font-weight: 600">kaz_new</span>.`,
          "Подтверждение",
          {
            confirmButtonText: "Удалить",
            cancelButtonText: "Отмена",
            type: "error",
            confirmButtonClass: "el-button--danger",
            dangerouslyUseHTMLString: true,
          }
        );

        this.loading = true;
        await deleteDictionary({ action: "delete_all" });
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div class="mng-page flex flex-col h-full w-full">
    <div class="mng-page__header flex-shrink-0">
      <div class="mng-page__title-row">
        <h1 class="mng-page__title">Словарь</h1>
      </div>
      <div class="mng-page__filters">
        <div class="flex flex-wrap items-center justify-end gap-3">
          <el-select
            v-model="selectedLang"
            placeholder="Язык"
            clearable
            style="width: 200px; margin-right: 10px"
          >
            <el-option
              v-for="language in languages"
              :label="language.title"
              :value="language.value"
              :key="language.value"
              >{{ language.title }}</el-option
            >
          </el-select>
          <el-button
            @click="reportDictionary"
            :loading="loading"
            type="success"
            plain
            style="margin-right: 10px"
            class="download_button"
          >
            <export-icon></export-icon>
            Скачать xlsx</el-button
          >
          <el-button
            type="danger"
            plain
            @click="deleteAllDictionary"
            :disabled="loading"
            style="margin: 0"
          >
            Удалить все
          </el-button>
        </div>
      </div>
    </div>
    <main
      class="mng-page__body flex-1 min-h-0 flex flex-col overflow-hidden"
      style="padding: 20px 26px"
    ></main>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/manage-page.scss";
</style>
